/**
 * Next.js runs this file on every page, after the HTML loads and before React
 * hydrates, so anything installed synchronously here is in place before the
 * first React DOM operation.
 */
import { installTranslationDomGuard } from './lib/translation-dom-guard'

installTranslationDomGuard()
